import React from "react";
import { Card } from "react-bootstrap";
import "./consultingContent.scss"

const ConsultingContent = () => {
  const cardContent = [
    {
      title: "Feasibility Studies:",
      service:
        "We analyse and assess the viability of new product, assess devices compatibility of the product and suggest suitable platforms for implementation.",
    },
    {
      title: "Proof-of-Concept:",
      service:
        "We create simple product prototype to ensure that the product features can be implemented. It can also be a great start to show your business concept to investors/customers/business partners.",
    },
    {
      title: "Technical and Functional Design:",
      service:
        "We capture your requirements and create a blueprint for development team.",
    },
    {
      title: "Requirements Analysis (free):",
      service:
        "We analyse and assess the customer’s requirements and Cube Globals’ efforts in order to bring your product to the market.",
    },
    {
      title: "Design and Code Review:",
      service:
        "We assess and provide our independent opinion on the current solution progress/code/architecture.",
    },
    {
      title: "System Architecture:",
      service:
        "We design flexible and scalable product architecture. With Cube Globals’ consulting services, many companies were able to improve their current product, find investors and receive valuable market insight.",
    },
  ];

  return (
    <div className="consulting-content-container">
      <div className="consulting-text-container">
        <p className="text-title">Cross Platform Consulting</p>
        <p>
          Cube Global provides expert guidance and advice on solutions across
          different platforms. Customers often turn to us to create demo
          applications, research the application devices compatibility and
          scalability, and improve features or usability of their current
          application.
        </p>
        <p>
          Thus, years of experience in mobile development enabled us to offer
          various consulting services to our customers, including proof of
          concept, feasibility studies, requirements analysis, review of code
          and design.
        </p>
      </div>

      <div className="consulting-cards-container">
        <p className="text-title">This is what our mobile consultants can do for you:</p>
        <div  className="cards">
          {cardContent.map((card, index) => (
            <Card className="card" key={index} >
              <Card.Body style={{display:"flex",alignItems:'center',justifyContent:"flex-start",padding:"29px"}} className="card-content">
                <Card.Text> <strong className="card-title">{card.title}</strong> {card.service}</Card.Text>
              </Card.Body>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ConsultingContent;
